exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".hbt-room-details-modal{padding:4px!important;width:760px!important}", ""]);

// exports
